import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeTriangleIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 3.16L21.4 19.44H2.6L12 3.16ZM5.7 17.6H18.3L12 6.7L5.7 17.6Z" />
    </SvgIcon>
  );
});
